import React from 'react';
import { Collapse } from 'antd';

const { Panel } = Collapse;

const SpecialitiesContent = () => {

  return (
    <section className="specialities-section p_relative">
            <div className="auto-container">
                <div className="row clearfix">
                    {/* <Collapse defaultActiveKey={['1']} onChange={() => {}}>
                        <Panel header="Clinical Services" key="1">
                            <p>
                            <ol>
                                <li>Cataract</li>
                                <li>Retina Services</li>
                                <li>Trauma</li>
                                <li>Squint &amp; Paediatric Ophthalmology</li>
                                <li>Orbit &amp; Oculoplasty</li>
                                <li>Refractive Surgery</li>
                                <li>Glaucoma</li>
                                <li>Cornea Services</li>
                                <li>Uvea Services</li>
                            </ol>
                            </p>
                        </Panel>
                        <Panel header="Related Services" key="2">
                            <p>
                            <ol>
                                <li>Outpatient Consultation</li>
                                <li>Contact Lens Clinic</li>
                                <li>Nursing</li>
                                <li>Optical Store</li>
                                <li>Contact Lens Services</li>
                                <li>Housekeeping</li>
                                <li>Emergency Eyecare Services</li>
                                <li>Operation Theatres Services</li>
                                <li>Pharmacy Services</li>
                                <li>Ambulance Services</li>
                                <li>Customer Care Service Desk</li>
                                <li>Billing Service Desk</li>
                                <li>Security Services</li>
                                <li>Facility Maintenance & Management Services</li>
                            </ol>
                            </p>
                        </Panel>
                        <Panel header="Diagnostic Services" key="3">
                            <p>
                            <ul>
                                <li>A Scan</li>
                                <li>B Scan</li>
                                <li>Computerized Eye Testing</li>
                                <li>Visual field Analysis</li>
                                <li>Pachymetry</li>
                                <li>Tonometry</li>
                                <li>OCT, FFA, Anterior Segment Photography</li>
                                <li>Squint Evaluation with Prism</li>
                                <li>Syringing</li>
                                <li>Schirmer's Test</li>
                                <li>Probing</li>
                                <li>Fundus Photography</li>
                            </ul>
                            </p>
                        </Panel>
                    </Collapse> */}


                    <div className="col-lg-12 col-md-12 col-sm-12 content-column">
                        <div className="content_block_nine">
                            <div className="content-box mr_30 p_relative">
                                <div className="sec-title-two mb_50">
                                    {/* <h5 className="mb_25">Faq's</h5> */}
                                    {/* <h2 className="d_block fs_40 fw_bold">Facilities and Services</h2> */}
                                </div>
                                <div className="accordion-inner">
                                    <ul className="accordion-box">
                                        <li className="accordion block active-block">
                                            <div className="acc-btn active">
                                                <div className="icon-outer"><i className="far fa-angle-down"></i></div>
                                                <h5>Clinical Services</h5>
                                            </div>
                                            <div className="acc-content current">
                                                <div className="text">
                                                <p>
                                                    <ol className="list-style-one clearfix">
                                                        <li>Cataract</li>
                                                        <li>Retina Services</li>
                                                        <li>Trauma</li>
                                                        <li>Squint &amp; Paediatric Ophthalmology</li>
                                                        <li>Orbit &amp; Oculoplasty</li>
                                                        <li>Refractive Surgery</li>
                                                        <li>Glaucoma</li>
                                                        <li>Cornea Services</li>
                                                        <li>Uvea Services</li>
                                                    </ol>
                                                </p>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="accordion block">
                                            <div className="acc-btn">
                                                <div className="icon-outer"><i className="far fa-angle-down"></i></div>
                                                <h5>Related Services</h5>
                                            </div>
                                            <div className="acc-content">
                                                <div className="text">
                                                    <p>
                                                        <ol className="list-style-one clearfix">
                                                            <li>Outpatient Consultation</li>
                                                            <li>Contact Lens Clinic</li>
                                                            <li>Nursing</li>
                                                            <li>Optical Store</li>
                                                            <li>Contact Lens Services</li>
                                                            <li>Housekeeping</li>
                                                            <li>Emergency Eyecare Services</li>
                                                            <li>Operation Theatres Services</li>
                                                            <li>Pharmacy Services</li>
                                                            <li>Ambulance Services</li>
                                                            <li>Customer Care Service Desk</li>
                                                            <li>Billing Service Desk</li>
                                                            <li>Security Services</li>
                                                            <li>Facility Maintenance & Management Services</li>
                                                        </ol>
                                                    </p>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="accordion block">
                                            <div className="acc-btn">
                                                <div className="icon-outer"><i className="far fa-angle-down"></i></div>
                                                <h5>Diagnostic Services</h5>
                                            </div>
                                            <div className="acc-content">
                                                <div className="text">
                                                    <p>
                                                        <ul className="list-style-one clearfix">
                                                            <li>A Scan</li>
                                                            <li>B Scan</li>
                                                            <li>Computerized Eye Testing</li>
                                                            <li>Visual field Analysis</li>
                                                            <li>Pachymetry</li>
                                                            <li>Tonometry</li>
                                                            {/* <li>OCT, FFA, Anterior Segment Photography</li> */}
                                                            <li>Squint Evaluation with Prism</li>
                                                            <li>Syringing</li>
                                                            <li>Schirmer's Test</li>
                                                            <li>Probing</li>
                                                            <li>Fundus Photography</li>
                                                        </ul>
                                                    </p>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
  }
  
  export default SpecialitiesContent;